/* src/components/pdf-page-footer/pdf-page-footer.component.scss */
app-pdf-page-footer {
  display: block;
  width: 100%;
  background: #fff;
}
.pdf-page__footer-body {
  display: flex;
  width: 100%;
  align-items: flex-end;
  justify-content: space-between;
}
/*# sourceMappingURL=pdf-page-footer.component-HA6OKJ6V.css.map */
